import React, { Dispatch } from 'react'
import {
  ExtraOptionRow,
  ExtraOptionPopOverStyled,
  PopOverWrapperStyled,
} from 'Features/domainsManagement/components/ExtraOptionPopOver/ExtraOptionPopOver.styled'

import { useTranslation } from 'react-i18next'

import { Trash } from 'Assets/icons/Trash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faKey } from '@fortawesome/pro-regular-svg-icons'
import { ActivityLine } from 'Assets/icons/ActivityLine'
import { ConfirmationModal } from 'Components/Elements/ConfirmationModal/ConfirmationModal'
import { useDeleteDomain } from 'Features/domainsManagement/api/deleteDomain'
import { Domain } from 'Types/Domain'
import { EditBoard } from 'Assets/icons/EditBoard'
import { PopOver } from 'Components/Elements/PopOver/PopOver'
import { ExtraOptionPopoverTrigger } from './ExtraOptionPopoverTrigger'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { MODALS_INIT_STATE } from '../DomainManagmentRow/DomainManagementRow'
import { GLOBAL_MODALS } from 'Types/GlobalModal'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { TagInstallation } from '../TagInstallation/TagInstallation'

type ExtraOptionsModalProps = {
  domain: Domain
  isOpen: boolean
  state: typeof MODALS_INIT_STATE
  onOpenChange: (open: boolean) => void
  modalsDispatch: Dispatch<{
    type: keyof typeof MODALS_INIT_STATE
    payload: boolean
  }>
}

export const ExtraOptionPopOver = ({
  domain,
  isOpen,
  state,
  onOpenChange,
  modalsDispatch,
}: ExtraOptionsModalProps) => {
  const { t } = useTranslation('domainManagement')
  const { setModalToShow, setCurrentDomain } = useAppStore()
  const { mutate, isLoading } = useDeleteDomain()
  const { owner, language } = useUserStore()

  const removeDomain = () => {
    mutate({ domainId: domain.id })
  }

  const onBmSetupClick = () => {
    setCurrentDomain(domain)
    setModalToShow(GLOBAL_MODALS.BM_SETUP)
  }

  const onEditDomainProducts = () => {
    setCurrentDomain(domain)
    setModalToShow(GLOBAL_MODALS.EDIT_DOMAIN_PRODUCTS)
  }

  return (
    <PopOverWrapperStyled>
      <PopOver trigger={<ExtraOptionPopoverTrigger />} isOpen={isOpen} onOpenChange={onOpenChange}>
        <ExtraOptionPopOverStyled
          language={language === 'es' ? 'es' : undefined}
          id="extra-options-modal"
          isHidden={
            state.showGetTagModal || state.showDomainProductModal || state.showConfirmationModal
          }
        >
          {(domain?.wordpress || domain?.botZappingPluginActivated) && (
            <ExtraOptionRow onClick={onBmSetupClick}>
              <FontAwesomeIcon icon={faKey as IconProp} />
              {t('see_plugin_keys')}
            </ExtraOptionRow>
          )}
          <ExtraOptionRow onClick={() => setModalToShow(GLOBAL_MODALS.CQ_PARAMS)}>
            <ActivityLine />
            {t('get_tracking_parameters')}
          </ExtraOptionRow>
          {owner && (
            <>
              <ExtraOptionRow onClick={onEditDomainProducts}>
                <EditBoard /> {t('edit_domain_products_option')}
              </ExtraOptionRow>
              <ExtraOptionRow
                onClick={() => modalsDispatch({ type: 'showConfirmationModal', payload: true })}
              >
                <Trash />
                {t('remove')}
              </ExtraOptionRow>
            </>
          )}
        </ExtraOptionPopOverStyled>
        {/* MODALS LAND */}
        <ConfirmationModal
          isOpen={state.showConfirmationModal}
          ctaAction={() => removeDomain()}
          title={t('remove_domain_modal.title', { domainName: domain.address })}
          description={t('remove_domain_modal.description', { domainName: domain.address })}
          ctaText={t('remove_domain_modal.yes_remove')}
          cancelText={t('remove_domain_modal.cancel')}
          loading={isLoading}
          onOpenChange={(open) => {
            onOpenChange(open)
            modalsDispatch({ type: 'showConfirmationModal', payload: false })
          }}
        />
        <TagInstallation
          isOpen={state.showGetTagModal}
          domainAddress={domain.address}
          onOpenChange={(open) => {
            onOpenChange(open)
            setModalToShow('')
            modalsDispatch({ type: 'showGetTagModal', payload: false })
          }}
        />
      </PopOver>
    </PopOverWrapperStyled>
  )
}
